import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { SmartEditCoreModule } from '@spartacus/smartedit/core';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SmartEditModule {
  static {
    this.ɵfac = function SmartEditModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SmartEditModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SmartEditModule,
      imports: [SmartEditCoreModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [SmartEditCoreModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartEditModule, [{
    type: NgModule,
    args: [{
      imports: [SmartEditCoreModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/*
 * Public API Surface of smartedit
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SmartEditModule };
